import { render } from "./TheCartOrderContacts.vue?vue&type=template&id=0df697ee"
import script from "./TheCartOrderContacts.vue?vue&type=script&lang=js"
export * from "./TheCartOrderContacts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__